import React from 'react';
import moment from 'moment';
import { truncate } from '../../../helpers';
import { getConfig } from '../../../utils/config';
import { useHistory } from 'react-router-dom';
import useHomeBlogs from './data';
import { winnreAuth, winnreNoAuth } from '../../../utils/axios';
import { useSelector } from 'react-redux';
import BlogCategory from '../../../Routes/Blogs/Components/BlogCategory';

function BlogLayoutVertical1({ hideInfo, className, classNameContainer }) {
    const config = getConfig();
    const { blogs } = useHomeBlogs();
    const history = useHistory();

    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const clickThroughMobile = clientWebview || internalWebview;

    const isUserAuthenticated = useSelector(
        (state) => state.auth.isAuthenticated
    );
    const userId = useSelector((state) => state.auth.userId);
    const blogClickedHandler = (blogId, visibleToAll) => {
        if (isUserAuthenticated) {
            winnreAuth({
                method: 'POST',
                url: `winnre/user/blogs/trackClick?blogId=${blogId}&userId=${userId}&sourcePlatform=${
                    clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                }`
                // headers: headers2
            })
                .then(() => {})
                .catch(() => {});
        } else {
            winnreNoAuth({
                method: 'POST',
                url: `winnre/user/blogs/trackClick?blogId=${blogId}&sourcePlatform=${
                    clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                }`
            })
                .then(() => {})
                .catch(() => {});
        }
        if (visibleToAll) {
            history.push(`/blogs/${blogId}`);
        } else {
            history.push(`/blogs`);
        }
    };
    return (
        <div
            className={`${
                className
                    ? className
                    : 'w-full h-auto flex flex-col-reverse lg:flex-row mt-10 px-5 lg:px-8 xl:px-2 2xl:px-10 justify-center '
            } pb-10`}
        >
            <div
                className={`pb-4 ${
                    classNameContainer
                        ? classNameContainer
                        : ' w-full px-5 md:px-0 xl:w-[80%] overflow-x-scroll lg:overflow-x-hidden flex lg:grid lg:grid-cols-3 gap-x-4 md:gap-x-8 lg:gap-x-6 xl:gap-x-10 3xl:gap-x-16 gap-y-14 '
                }`}
            >
                {/* {blogs?.map((blog) => {
                    // console.log('v', blog.visibleToAll);
                    return (
                        <div
                            key={blog.id}
                            onClick={() =>
                                blogClickedHandler(blog.id, blog.visibleToAll)
                            }
                            className="text-left min-w-[80vw] lg:min-w-full  bg-white rounded-sm flex flex-col justify-center h-auto shadow-xl hover:shadow-2xl cursor-pointer mb-14"
                        >
                            <div className="relative h-full">
                                {hideInfo ? (
                                    <></>
                                ) : (
                                    <BlogCategory categories={blog?.tags} />
                                )}

                                <img
                                    src={blog?.displayImageUrl}
                                    className=" h-[200px] w-full rounded-t-sm object-cover"
                                    alt="Blog image"
                                />
                            </div>
                            <div className="h-auto">
                                <div className="h-auto ">
                                    <h2
                                        className={` ${config?.blogs.fontHeading} m-5 break-words leading-6 uppercase text-black font-medium
                                        ${config?.blogs.layout5.headingClass}
                                    `}
                                    >
                                        {truncate(blog.heading, 15)}
                                    </h2>
                                    {hideInfo ? (
                                        <></>
                                    ) : (
                                        <>
                                            <img
                                                src="https://d1pkuz21mplpj3.cloudfront.net/SVG/Divider-2.svg"
                                                className="w-full"
                                            />

                                            <div className="flex font-Roboto justify-between  border-gray-200 mx-5 py-5 3xl:pt-5">
                                                <div className="flex space-x-4">
                                                    <img
                                                        src="https://d1pkuz21mplpj3.cloudfront.net/SVG/Like_icon.svg"
                                                        className="w-[18px] md:w-[22px]"
                                                    />
                                                    <img
                                                        src="https://d1pkuz21mplpj3.cloudfront.net/SVG/share_icon.svg"
                                                        className="w-[16px] md:w-[20px]"
                                                    />
                                                    <img
                                                        src="https://d1pkuz21mplpj3.cloudfront.net/SVG/comment_icon.svg"
                                                        className="w-[21px] md:w-[25px]"
                                                    />
                                                </div>

                                                <p
                                                    className={
                                                        'font-Gotham_Light  text-[14px] md:text-[17px] xl:text-[15px]  self-center text-[#919396]'
                                                    }
                                                >
                                                    {moment(
                                                        blog?.publishDate
                                                            ? blog?.publishDate
                                                            : blog?.updatedOn
                                                    ).format('DD.MM.YY')}
                                                </p>
                                            </div>
                                        </>
                                    )}
                                    <p
                                        className={` mx-5 mt-2 text-[#343434] ${
                                            config?.blogs.fontBody
                                        }  ${
                                            config?.blogs.layout5.summaryClass
                                                ? config?.blogs.layout5
                                                      .summaryClass
                                                : 'text-[16.5px] xl:text-[17px] leading-6'
                                        }`}
                                    >
                                        {truncate(blog.summary, 28) + ' ...'}
                                    </p>
                                    <div className="flex w-full flex-col mt-10">
                                        <button
                                            className={`  ${
                                                config?.blogs.fontBody
                                            }  flex justify-center  py-2 px-4 m-4 text-[13px] xl:text-[15px] ${
                                                config?.blogs.button.bgColor
                                                    ? 'bg-primary text-white'
                                                    : 'text-black'
                                            } ${
                                                config?.blogs.button.position
                                            } ${
                                                config?.blogs.layout5
                                                    .buttonClass
                                            } ${
                                                config?.blogs.button?.border
                                                    ? 'border-primary border-[3px] text-black'
                                                    : ''
                                            }
                                    `}
                                            style={{
                                                backgroundColor:
                                                    !config?.blogs.button
                                                        ?.border &&
                                                    config?.blogs?.primaryColor
                                            }}
                                        >
                                            READ MORE
                                            <span className=" inline-block self-center h-4">
                                                <img
                                                    src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.16 11.59'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23${
                                                        config?.blogs?.layout5
                                                            ?.buttonArrow
                                                            ? config?.blogs
                                                                  ?.layout5
                                                                  ?.buttonArrow
                                                            : 'fff'
                                                    };stroke-miterlimit:10;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cline class='cls-1' y1='5.62' x2='55' y2='5.62'/%3E%3Cpolyline class='cls-1' points='48.5 0.39 51.93 3.09 55.35 5.79 51.93 8.49 48.5 11.19'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`}
                                                    className="h-4 w-[20px] xl:w-[40px] ml-4"
                                                />
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })} */}
                {/* TEST */}
                {blogs?.map((blog) => (
                    <div
                        onClick={() =>
                            blogClickedHandler(blog.id, blog.visibleToAll)
                        }
                        className={`${
                            config?.darkMode
                                ? 'bg-black border-[1px] border-primary'
                                : 'bg-white'
                        } flex flex-col h-auto rounded-lg shadow-xl hover:shadow-2xl cursor-pointer mb-2 text-left min-w-[80vw] md:min-w-[50vw] lg:min-w-full justify-center`}
                    >
                        <div className="relative max-h-52 3xl:h-72 ">
                            {hideInfo ? (
                                <></>
                            ) : (
                                <BlogCategory categories={blog?.tags} />
                            )}
                            <img
                                src={blog.displayImageUrl}
                                className="h-52 3xl:h-72 w-full rounded-t-md object-cover"
                                alt="Blog image"
                            />
                        </div>
                        <div className="p-4 text-left">
                            <h2
                                className={`mt-2 xl:mt-4 ${
                                    config?.blogs.fontHeading
                                } break-words leading-6 uppercase ${
                                    config?.darkMode
                                        ? 'text-white'
                                        : 'text-black '
                                } font-medium ${
                                    config?.blogs.layout5.headingClass
                                }`}
                                title={blog.heading}
                            >
                                {truncate(blog.heading, 10)}
                            </h2>
                            <p
                                className={`mt-6 xl:mt-12 mb-5 ${
                                    config?.darkMode
                                        ? 'text-[#9b9b9b]'
                                        : 'text-[#343434]'
                                } ${config?.blogs.fontBody}  ${
                                    config?.blogs.layout5.summaryClass
                                        ? config?.blogs.layout5.summaryClass
                                        : 'text-[16.5px] xl:text-[17px] leading-6'
                                }`}
                            >
                                {truncate(blog.summary, 18) + ' ...'}
                            </p>
                        </div>

                        <div className="mt-auto flex flex-col justify-between text-sm">
                            <button
                                className={`  ${
                                    config?.blogs.fontBody
                                }  flex justify-center  py-2 px-4 m-4 text-[13px] xl:text-[15px] ${
                                    config?.blogs.button.bgColor
                                        ? 'bg-primary text-white'
                                        : 'text-black'
                                } ${config?.blogs.button.position} ${
                                    config?.blogs.layout5.buttonClass
                                } ${
                                    config?.blogs.button?.border
                                        ? 'border-primary border-[3px] text-black'
                                        : ''
                                }
                                        `}
                                style={{
                                    backgroundColor:
                                        !config?.blogs.button?.border &&
                                        config?.blogs?.primaryColor
                                }}
                            >
                                READ MORE
                                <span className=" inline-block self-center h-4">
                                    <img
                                        src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.16 11.59'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23${
                                            config?.blogs?.layout5?.buttonArrow
                                                ? config?.blogs?.layout5
                                                      ?.buttonArrow
                                                : 'fff'
                                        };stroke-miterlimit:10;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cline class='cls-1' y1='5.62' x2='55' y2='5.62'/%3E%3Cpolyline class='cls-1' points='48.5 0.39 51.93 3.09 55.35 5.79 51.93 8.49 48.5 11.19'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`}
                                        className="h-4 w-[20px] xl:w-[40px] ml-4"
                                    />
                                </span>
                            </button>
                            {hideInfo ? (
                                <></>
                            ) : (
                                <div
                                    className={`flex justify-between ${
                                        config?.darkMode ? 'border-primary' : ''
                                    }  border-t px-5 py-2 xl:py-3 mt-2 xl:mt-4`}
                                >
                                    <div className="flex space-x-4">
                                        <img
                                            src="https://d1pkuz21mplpj3.cloudfront.net/SVG/Like_icon.svg"
                                            className="w-[18px] md:w-[22px]"
                                        />
                                        <img
                                            src="https://d1pkuz21mplpj3.cloudfront.net/SVG/share_icon.svg"
                                            className="w-[16px] md:w-[20px]"
                                        />
                                        <img
                                            src="https://d1pkuz21mplpj3.cloudfront.net/SVG/comment_icon.svg"
                                            className="w-[21px] md:w-[25px]"
                                        />
                                    </div>

                                    <p
                                        className={
                                            'font-Gotham_Light  text-[14px] md:text-[17px] xl:text-[15px]  self-center text-[#919396]'
                                        }
                                    >
                                        {moment(
                                            blog?.publishDate
                                                ? blog?.publishDate
                                                : blog?.updatedOn
                                        ).format('DD.MM.YY')}
                                    </p>
                                </div>
                            )}
                            {/* <div
                                className={` ${config?.blogs.fontBody} ${
                                    config?.blogs.layout5?.dateClass ||
                                    'text-[14px] lg:text-[15px] xl:text-[14px] 2xl:text-[14px] text-[#343434]'
                                } flex justify-between space-x-4 md:space-x-10  lg:space-x-6 xl:space-x-4 border-t px-4 py-3 `}
                            >
                                <p>
                                    {moment(
                                        blog?.publishDate
                                            ? blog?.publishDate
                                            : blog?.updatedOn
                                    ).format('Do MMMM YYYY')}
                                </p>
                                <p>
                                    {blog.commentsCount === 0
                                        ? 'No comments'
                                        : blog.commentsCount + ' comments'}
                                </p>
                            </div> */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default BlogLayoutVertical1;
